import { Box, Stack, Text } from 'braid-design-system';
import React, { type ReactNode } from 'react';

interface Props {
  label: string;
  id: string;
  children: ReactNode;
}

const CheckoutFormField = ({ label, id, children }: Props) => (
  <Stack space="small">
    <Text>{label}</Text>
    <Box padding="xsmall" boxShadow="borderNeutralLight" id={id}>
      {children}
    </Box>
  </Stack>
);

export default CheckoutFormField;
